import config from "../../config/config.json";
import sha256 from "crypto-js/sha256";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithoutAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse,
  headersWithoutAuthWithoutBody
} from "../../APIHelpers/Responses";

export const authServices = {
  login,
  logout,

  checkRegistrationSetup,
  userRegistration,
  setUpAccount,
  setUpPassword,
  forgotPassword,
  resetPassword,

  generateQRForWebLogin,
  qrWebLogin,

  generateQRForMobileLogin,

  getDeviceFingerprint,
};

async function login(userData) {
  userData.deviceFingerprint = await getDeviceFingerprint()
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}login`,
    headersWithoutAuth("POST", userData)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  if (data.statusCode === 200) {
    const newUser = {
      name: data?.name,
      email: data?.email,
    };
    const existingList =
      JSON.parse(localStorage.getItem("accountList")) || [];
    const isEmailExists = existingList.some(
      (item) => item.email === newUser.email
    );
    if (!isEmailExists) {
      existingList.push(newUser);
    }
    localStorage.setItem("accountList", JSON.stringify(existingList));
    localStorage.setItem("theme-mode", data.themeSettings);
    localStorage.setItem("primaryColor", data.primaryColor);
    localStorage.setItem("secondaryColor", data.secondaryColor);
    localStorage.setItem("token", data.token);
    window.location.reload();
  }
  return data;
}

async function getDeviceFingerprint() {
  const fingerprintString = [
    navigator.userAgent,
    navigator.platform,
    window.screen.width,
    window.screen.height,
    window.screen.colorDepth,
    navigator.language,
    new Date().getTimezoneOffset()
  ].join("|");

  const hash = sha256(fingerprintString).toString();
  return hash;
};

async function logout() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}logout`,
    headersWithAuth("PUT", {}, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  if ((data?.statusCode === 200)) {
    localStorage.removeItem("themeSettings");
    sessionStorage.clear();
    window.location.reload();
  }
}

// Check Registration Setup
async function checkRegistrationSetup(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}checkRegistrationSetup`,
    headersWithoutAuth("POST", userData)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  return data;
}

// User Registeration
async function userRegistration(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}userRegistration`,
    headersWithoutAuth("POST", userData)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  return data;
}

// Setup Account
async function setUpAccount(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}setUpAccount`,
    headersWithoutAuth("POST", userData)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  return data;
}

// Setup Password
async function setUpPassword(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}setUpPassword`,
    headersWithoutAuth("POST", userData)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  return data;
}

// Forgot Password
async function forgotPassword(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}forgotPassword`,
    headersWithoutAuth("PUT", userData)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

// Reset Password
async function resetPassword(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}resetPassword`,
    headersWithoutAuth("PUT", userData)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

// Generate QR For Auto Login
async function generateQRForWebLogin() {
  try {
    const signal = cancelPreviousRequest("generateQRForWebLogin");
    let apiURL = `${config.API_URL_USER_ONBOARDING}generateQRForWebLogin`
    const response = await fetch(apiURL, {
      ...headersWithoutAuthWithoutBody("GET"),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// QR Web Login
async function qrWebLogin(userData) {
  userData.deviceFingerprint = await getDeviceFingerprint()
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}qrWebLogin`,
    headersWithoutAuth("POST", userData)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  if (data.statusCode === 200) {
    window.location.href = "/home";
  }
  return data;
}

// Generate QR For Mobile Login
async function generateQRForMobileLogin() {
  try {
    const signal = cancelPreviousRequest("generateQRForMobileLogin");
    let apiURL = `${config.API_URL_USER_ONBOARDING}generateQRForMobileLogin`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}